import React from 'react';
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';
import AboutCompany from '../Elements/AboutCompany';
import Specialization3 from '../Elements/Specialization3';
import OurServices3 from '../Elements/OurServices3';
import OurValue3 from '../Elements/OurValue3';
import OurProject3 from '../Elements/OurProject3';
import Faq from '../Elements/Faq';
import AboutCompany3 from './AboutCompany3';
import Specialization7 from './Specialization7';
import OurValue7 from './OurValue7';
import OurProject7 from './OurProject7';
import Faq3 from './Faq3';

var bnrimg = require('./../../images/banner/1.jpg');

class ElectricalInstrumentation extends React.Component {
    render() {
        return (
            <>

                <Header />
                <div className="page-content">
                    <Banner title="Diversified services. Unvarying quality." pagename="Services" bgimage={bnrimg}/>
                    <AboutCompany3 />
                    <Specialization7 />
                    <OurValue7/>
                    <OurProject7 />
                    {/* <Faq3 /> */}
                <Footer />
                    
                </div>

                
               

            </>
        );
    };
};

export default ElectricalInstrumentation;